import React, { useState } from 'react';
import {
  Box,
  Grid,
  Typography,
  Paper,
  useMediaQuery,
  Container,
  Pagination,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import GroupIcon from '@mui/icons-material/Group';

const HeroSection = styled(Box)(({ theme }) => ({
  background: 'linear-gradient(135deg, #01B7EA 0%, #0288D1 100%)',
  color: '#FFFFFF',
  padding: theme.spacing(10, 2),
  textAlign: 'center',
  marginTop: '64px',
  marginBottom: theme.spacing(6),
  '&::before': {
    content: '""',
    position: 'absolute',
    inset: 0,
    background: 'url("/pattern.png")',
    opacity: 0.1,
  },
}));

const MemberCard = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(3),
  borderRadius: theme.spacing(2),
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(3),
  backgroundColor: '#FAFAFA',
  border: '1px solid rgba(0, 0, 0, 0.05)',
  boxShadow: 'none',
  transition: '0.3s ease',
  '&:hover': {
    transform: 'translateY(-3px)',
    boxShadow: '0 6px 20px rgba(0, 0, 0, 0.05)',
  },
}));

const MembersWrapper = styled(Box)(({ theme }) => ({
  backgroundColor: '#F9FBFC',
  padding: theme.spacing(6, 2),
  borderRadius: theme.spacing(2),
}));

const MembersList = () => {
  const isMobile = useMediaQuery('(max-width:600px)');
  const membersPerPage = 15;

 const members = [
  { id: 1, name: 'HUNDEE – Oromo Grassroots Development Initiative', role: 'Member' },
  { id: 2, name: 'Facilitators for Change (FC)', role: 'Member' },
  { id: 3, name: 'Action for Development (AFD)', role: 'Member' },
  { id: 4, name: 'Rift Valley Children and Women Development Organization (RCWDO)', role: 'Member' },
  { id: 5, name: 'Center for Development Initiative (CDI)', role: 'Member' },
  { id: 6, name: 'Harmee Education for Development Association (HEfDA)', role: 'Member' },
  { id: 7, name: 'GURMUU Development Association', role: 'Member' },
  { id: 8, name: 'African Development Aid Association (ADAA)', role: 'Member' },
  { id: 9, name: 'Education for Development Association (EFDA)', role: 'Member' },
  { id: 10, name: 'Sustainable Environmental and Development Association (SEDA)', role: 'Member' },
  { id: 11, name: 'Organization for Development in Action (ODA)', role: 'Member' },
  { id: 12, name: 'Gaayoo Pastoralist Development Initiative (GDPI)', role: 'Member' },
  { id: 13, name: 'Girja Integrated Rural Development Association (GIRDA)', role: 'Member' },
  { id: 14, name: 'Ilu Women and Children Integrated Development Association (IWCIDA)', role: 'Member' },
  { id: 15, name: 'Stand for the Vulnerable Organization (SVO)', role: 'Member' },
  { id: 16, name: 'Vision for Community Development Association (VCDA)', role: 'Member' },
  { id: 17, name: 'Wako Gutu Foundation (WGF)', role: 'Member' },
  { id: 18, name: 'Charity and Development Association (CDA)', role: 'Member' },
  { id: 19, name: 'Association for Development and Biodiversity Conservation (ADBC)', role: 'Member' },
  { id: 20, name: 'Center for Development and Governance (CDG)', role: 'Member' },
  { id: 21, name: 'Mothers and Children Development Organization', role: 'Member' },
  { id: 22, name: 'Action for Basic Development Initiative (ABDI)', role: 'Member' },
  { id: 23, name: 'Tarkanfi Sustainable Development Organization (TSO)', role: 'Member' },
  { id: 24, name: 'El-Derash Children and Family Development Organization', role: 'Member' },
  { id: 25, name: 'Shalom Charity Organization (SCO)', role: 'Member' },
  { id: 26, name: 'Save Generation Development Association (SGDA)', role: 'Member' },
  { id: 27, name: 'Oromo Relief Association (ORA)', role: 'Member' },
  { id: 28, name: 'Siiqee Women Development Association (SWDA)', role: 'Member' },
  { id: 29, name: 'Hope Integrated Social Development', role: 'Member' },
  { id: 30, name: 'Center for Innovation and Excellence in Entrepreneurship Development-Africa (CIED-AFRICA)', role: 'Member' },
  { id: 31, name: 'New Vision in Development Association (NVDA)', role: 'Member' },
  { id: 32, name: 'Ethiopian Evangelical Church Mekane Yesus (EECMY)', role: 'Member' },
  { id: 33, name: 'Life with Environment', role: 'Member' },
  { id: 34, name: 'Professional Alliance for Development (PADet)', role: 'Member' },
  { id: 35, name: 'Strategies for Northern Development (SND Africa)', role: 'Member' },
  { id: 36, name: 'Hirko Education Support and Development Organization', role: 'Member' },
  { id: 37, name: 'Ethiopian Midwives Association (EMwA)', role: 'Member' },
  { id: 38, name: 'Gadisa Lemi Humanitarian Organization (GLHO)', role: 'Member' },
  { id: 39, name: 'Society for Talent Building of Youth in Ethiopia', role: 'Member' },
  { id: 40, name: 'Sustainable Natural Resources Management Association (SUNARMA)', role: 'Member' },
  { id: 41, name: 'Community Initiatives Facilitation and Assistance (CIFA)', role: 'Member' },
  { id: 42, name: 'Chaya Humanitarian Organization (CHO)', role: 'Member' },
  { id: 43, name: 'Akmon Initiative for Development (AID)', role: 'Member' },
  { id: 44, name: 'Alliance for Integrated Dev’t & Relief Organization (AIDRO)', role: 'Member' },
  { id: 45, name: 'Green Love Appreciative Development (GLAD)', role: 'Member' },
  { id: 46, name: 'Pastoralist Initiative Development Aid (PiDA)', role: 'Member' },
  { id: 47, name: 'Gudina Tumsa Foundation (GTF)', role: 'Member' },
  { id: 48, name: 'Noble Action Holistic Development', role: 'Member' },
];


  const [currentPage, setCurrentPage] = useState(1);

  const totalPages = Math.ceil(members.length / membersPerPage);
  const startIndex = (currentPage - 1) * membersPerPage;
  const currentMembers = members.slice(startIndex, startIndex + membersPerPage);

  const handlePageChange = (event, page) => {
    setCurrentPage(page);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <Box>
      <HeroSection>
        <Container maxWidth="lg">
          <GroupIcon sx={{ fontSize: 48, mb: 2 }} />
          <Typography variant="h3" sx={{ fontWeight: 700, mb: 1 }}>
            Our Members
          </Typography>
        </Container>
      </HeroSection>

      <Container maxWidth="lg">
        <MembersWrapper>
          <Grid container spacing={4}>
            {currentMembers.map((member) => (
              <Grid item xs={12} sm={6} md={4} key={member.id}>
                <MemberCard>
                  <img
                    src="/logo-necsoo.png"
                    alt="NeCSOO Logo"
                    style={{
                      height: isMobile ? '50px' : '70px',
                      width: 'auto',
                      transition: 'all 0.3s ease',
                      filter: 'drop-shadow(0 1px 3px rgba(0,0,0,0.05))',
                    }}
                  />
                  <Box>
                    <Typography
                      variant="subtitle1"
                      sx={{ fontWeight: 600, color: '#111827' }}
                    >
                      {member.name}
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{ color: '#6B7280' }}
                    >
                      {member.role}
                    </Typography>
                  </Box>
                </MemberCard>
              </Grid>
            ))}
          </Grid>

          <Box sx={{ display: 'flex', justifyContent: 'center', mt: 6 }}>
            <Pagination
              count={totalPages}
              page={currentPage}
              onChange={handlePageChange}
              shape="rounded"
              color="primary"
              sx={{
                '& .MuiPaginationItem-root': {
                  fontWeight: 600,
                  borderRadius: 1,
                },
              }}
            />
          </Box>
        </MembersWrapper>
      </Container>
    </Box>
  );
};

export default MembersList;
